import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { makeStyles } from '@mui/styles';
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../../../routes";

const useStyles = makeStyles({
  container: {
    marginTop: '25px'
  },
  button: {
    display: "flex",
    alignItems: "center",
    "& > span": {
      marginLeft: "5px"
    }
  }
});

export const CompanyBackButton = () => {
  const classes = useStyles();
  const history = useNavigate();

  const onBackButtonClick = () => {
    history(Routes.badges);
  }

  return (
    <Box className={classes.container}>
      <Button className={classes.button} onClick={onBackButtonClick} data-testid="back-button">
        <ArrowBackIcon fontSize={"small"} />
        <span>Back</span>
      </Button>
    </Box>
  );
};
